import React, { FC } from 'react';
import Modal from 'react-modal';
import { Loader } from 'semantic-ui-react';
import { FinanceResponseAudit } from '@upstart/harmony/lib/legos/financingTypes';
import { modalOverlayBackgroundColor } from 'util/constants';
import CloseIcon from '../../../components/Icons/Close';
import './OfferHistoryModal.scss';
import { LogGroup } from './LogGroup';

export const modalStyle = {
  overlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: modalOverlayBackgroundColor,
  },
  content: {
    top: 'unset',
    bottom: 'unset',
    left: 'unset',
    right: 'unset',
    minWidth: '1024px',
    maxWidth: '1200px',
    minHeight: '300px',
    maxHeight: '500px',
    display: 'flex',
    flexDirection: 'column',
  },
} as const;

export const OfferHistoryModal: FC<{
  isOpen: boolean;
  isLoading: boolean;
  financeResponseAudit?: FinanceResponseAudit;
  onClose: () => void;
}> = props => (
  <Modal style={modalStyle as any} isOpen={props.isOpen}>
    <CloseIcon onClick={props.onClose} />
    <div className="offerHistoryTitleContainer">
      <div className="offerHistoryTitle">History</div>
    </div>
    {props.isLoading && (
      <div className="loaderContainer">
        <Loader size={'medium'} active inline />
      </div>
    )}
    {!props.isLoading && props.financeResponseAudit && (
      <div className="offerHistoryListContainer">
        {props.financeResponseAudit.logs?.map(changeSet => (
          <LogGroup
            changeSet={{
              changeLogs: changeSet.changeLogs,
              createdAt: changeSet.createdAt,
              createdBy: changeSet.createdBy,
            }}
          />
        ))}
      </div>
    )}
    {!props.isLoading && !props.financeResponseAudit && (
      <div className="loaderContainer">
        <div>No changes found.</div>
      </div>
    )}
  </Modal>
);
